import { HomeOutlined, SignatureOutlined, UserOutlined } from '@ant-design/icons';

export interface IRoute {
  path: string;
  title: string;
  description?: string;
  permission?: string;
  icon?: any;
  children?: IRoute[];
  isAdmin?: boolean;
}

export enum Route {
  PAGE500 = 'PAGE500',
  PAGE403 = 'PAGE403',

  LOGIN = 'LOGIN',

  HOME = 'HOME',
  THONG_TIN_CA_NHAN = 'THONG_TIN_CA_NHAN',
  CHAM_CONG = 'CHAM_CONG',
}

export const Routes: { [key in Route]: IRoute } = {
  PAGE500: {
    path: '/loi',
    title: 'Lỗi hệ thống',
  },
  PAGE403: {
    path: '/loi-quyen-truy-cap',
    title: 'Lỗi quyền truy cập',
  },

  LOGIN: {
    path: '/dang-nhap',
    title: 'Đăng nhập',
  },

  HOME: {
    path: '/',
    title: 'Trang chủ',
    icon: <HomeOutlined />,
  },

  THONG_TIN_CA_NHAN: {
    path: '/thong-tin-ca-nhan',
    title: 'Thông tin cá nhân',
    icon: <UserOutlined />,
  },

  CHAM_CONG: {
    path: '/cham-cong',
    title: 'Chấm công',
    icon: <SignatureOutlined />,
  },
};
